// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__2vQlI","label":"Switch_label__2JxF0","button":"Switch_button__2MZj_","isActivated":"Switch_isActivated__2xkQp"};